import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { isClassicEditorHost } from '../../utils/get-editor-host';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const getSaveChangesErrorModalProps = (t, editorHost, errorMessage) => ({
  content: isClassicEditorHost(editorHost) ? errorMessage || t('accessibility-wizard.save-error-modal.content') : /*#__PURE__*/React.createElement(Text, null, errorMessage || t('accessibility-wizard.save-error-modal.content')),
  primaryButtonText: t('accessibility-wizard.save-error-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.save-error-modal.secondary-button'),
  theme: 'destructive',
  title: t('accessibility-wizard.save-error-modal.title')
});
export const showSaveErrorModal = async _ref => {
  let {
    errorMessage,
    biLogger,
    handleTryAgain,
    a11yWizardAdapter,
    t,
    editorHost
  } = _ref;
  const modalProps = {
    ...getSaveChangesErrorModalProps(t, editorHost, errorMessage),
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.TryAgain,
        modalType: BiModalTypes.CantSaveChanges
      });
      handleTryAgain();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.Cancel,
        modalType: BiModalTypes.CantSaveChanges
      });
    }
  };
  biLogger.modalView({
    modalType: BiModalTypes.CantSaveChanges
  });
  if (isClassicEditorHost(editorHost)) {
    await a11yWizardAdapter.showDialog(modalProps);
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-save-error-modal.js.map